module.exports = __webpack_public_path__ + "images/puzzle/Puzzle/PNG/Piece02.b20c2675b615a149787083714fb4d582.png";